module.exports = __webpack_public_path__ + "img/step_2.19f5dd71.png";